export default "__VITE_ASSET__C0G_WkoK__"